<template>
  <div class="is-marginless is-paddingless section section-details" v-if="lotPaiement">
    <div class="entete border-entete">
      <div class="level">
        <div class="level-left">
          <div class="columns is-gapless">
            <div class="column">
              <h1 class="title is-size-3">
                {{ libelleLotPaiement }}
              </h1>
              <app-breadcrumb :breadcrumb="breadcrumb"/>
            </div>
          </div>
        </div>
        <div class="level-right">
          <div class="buttons">
            <a @click="$router.go(-1)"
               class="button is-cancel btn-modal-annuler">
              {{ $t('general.button.return')}}
            </a>
            <button class="button is-addOrEdit" v-if="lotPaiement.etat === constantes.ENCOURS"
                    @click="save()">
              {{ $t('general.button.sauvegarder') }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <error-msg-component :messages="messages"
                         :error="error"
                         class="mgt-20px"
                         :messagesChampsVide="messagesChampsVide"
                         :champsVide="champsVide"
                         :title="'editionClient.problemOccurred'"
                         :withEmplyFields="true"
                         @close="error = $event"/>
    <detail-lot-paiement :detail-lot-paiement="detailLotPaiement"
                         :lot-paiement="lotPaiement"
                         :is-detail="false">
    </detail-lot-paiement>
  </div>
</template>

<script>

import cloneDeep from 'lodash/cloneDeep';
import translate from '@/services/baux/lotPaiement/translator';
import formatDate from '@/services/general/formatIsoDate';
import { update, get } from '@/api/remiseBancaire';
import messageSucces from '@/services/general/messageSucces';
import messageErreur from '@/services/general/messageErreur';
import validationGeneral from '@/services/validation/validation';
import { getByRemiseBancaire, updateAllReferencePaiement } from '@/api/mouvementClient/index';
import formatCodeRemiseBancaire from '@/services/remiseBancaire/creationCodeRemiseBancaire';
import { SENS_ACHAT, MODULE_TLPE, MODULE_ACHAT } from '@/configuration/devisConf';
import { ENCOURS } from '@/configuration/remiseBancaire/remiseBancaireConf';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import breadcrumb from '@/components/general/breadcrumb';
import detailLotPaiement from '@/components/baux/lotPaiement/c_ligneLotPaiement';

export default {
  data() {
    return {
      lotPaiement: null,
      detailLotPaiement: [],
      messages: [],
      champsVide: [],
      messagesChampsVide: [],
      error: false,
      libelleLotPaiement: null,
      constantes: {
        ENCOURS,
      },
      moduleDcf: null,
    };
  },
  components: {
    appBreadcrumb: breadcrumb,
    errorMsgComponent,
    detailLotPaiement,
  },
  computed: {
    getNameRouteListe() {
      if (this.moduleDcf === MODULE_TLPE) return 'l.gabed.lot_paiement_recette';
      if (this.moduleDcf === MODULE_ACHAT) return 'l.achat.lot_paiements_factures';
      return 'l.baux.lot_paiement';
    },
    getNameBreadcrumbTitle() {
      if (this.moduleDcf === MODULE_TLPE) return this.$t('listeLotPaiement.titreRecette');
      if (this.moduleDcf === MODULE_ACHAT) return this.$t('listeLotPaiement.titreFactureAchat');
      return this.$t('detailLotPaiement.breadcrumb.listeLotPaiement');
    },
    breadcrumb() {
      return [
        { title: this.$t('editLotPaiement.breadcrumb.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        {
          title: this.getNameBreadcrumbTitle,
          route: { name: this.getNameRouteListe },
          isActive: false,
        },
        { title: this.libelleLotPaiement, route: '', isActive: true },
      ];
    },
    geNameRouteDetail() {
      if (this.moduleDcf === MODULE_TLPE) return 'c.gabed.lot_paiement_recette';
      if (this.moduleDcf === MODULE_ACHAT) return 'c.achat.lot_paiements_factures';
      return 'c.baux.lot_paiement';
    },
  },
  methods: {
    async save() {
      const loadingComponent = this.$buefy.loading.open();
      this.champsVide = [];
      this.messagesChampsVide = [];
      this.error = false;
      this.messages = [];
      try {
        const lotPaiement = cloneDeep(this.lotPaiement);
        lotPaiement.dateRemise = formatDate(lotPaiement.dateRemise);
        await update(lotPaiement);
        await updateAllReferencePaiement(this.detailLotPaiement.map((mouvement) => {
          return {
            id: mouvement.id,
            referencePaiement: mouvement.ligneRemiseBancairePseudoEntity.referenceReglement,
            dateMouvement: formatDate(mouvement.dateMouvement),
            dateEffet: formatDate(mouvement.ligneRemiseBancairePseudoEntity.dateEffet),
          };
        }));
        messageSucces(this.$t('editLotPaiement.messages.successUpdate'));
        this.$router.push({
          name: this.geNameRouteDetail,
          params: { id: this.lotPaiement.id },
        });
        loadingComponent.close();
      } catch (e) {
        if (e.response && e.response.data.error) {
          validationGeneral(this.$i18n, e.response, this.champsVide, this.messages,
            this.messagesChampsVide, translate);
          this.error = true;
        } else messageErreur(this.$i18n);
        loadingComponent.close();
        throw (e);
      }
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      const lotPaiement = (await get(this.$route.params.id)).data.result;
      this.moduleDcf = lotPaiement.module;
      lotPaiement.dateRemise = new Date(lotPaiement.dateRemise);
      this.libelleLotPaiement = this.$i18n.t('editLotPaiement.title') + formatCodeRemiseBancaire(lotPaiement.num, lotPaiement.nom, SENS_ACHAT);
      this.lotPaiement = lotPaiement;
      const detailLotPaiement = (await getByRemiseBancaire(this.lotPaiement.id)).data.result;
      detailLotPaiement.forEach((el) => {
        el.selected = false;
        el.montant = el.debit - el.credit;
      });
      this.detailLotPaiement = detailLotPaiement;
      this.setInformationPage(this.$t('pageGeneral.modification', { item: formatCodeRemiseBancaire(this.lotPaiement.num, this.lotPaiement.nom, this.sens) }));
      loadingComponent.close();
    } catch (e) {
      loadingComponent.close();
      throw e;
    }
  },
};

</script>
